import { useCallback, useState } from "react";

import { TradeCommand } from "../../../../services/holdings";
import { UseTradeCorrectionPanelReturn } from "./types";

// Captures the whole command, not its id (unlike usePriceOverridePanel's derived target) — the clicked row is already loaded with every default the form needs, so deriving it again would reintroduce refetch-timing questions.
export const useTradeCorrectionPanel = (): UseTradeCorrectionPanelReturn => {
  const [panel, setPanel] = useState<UseTradeCorrectionPanelReturn["panel"]>({
    isOpen: false,
    command: null,
  });

  const openPanel = useCallback((command: TradeCommand) => {
    setPanel({ isOpen: true, command });
  }, []);

  const closePanel = useCallback(() => {
    setPanel((current) => ({ ...current, isOpen: false, command: null }));
  }, []);

  return { panel, openPanel, closePanel };
};
